<div class="new-footer-inline" [style.--container-height.px]="deviceHeight">
  <div class="new-footer-header">
    <div class="title">{{ 'Scheduled Exports' }}</div>
    <button class="modal-close" (click)="closeOverlay()">✕</button>
  </div>
  <div class="overlay-panel" (click)="$event.stopPropagation()">
    <div class="scheduled-exports-container" *ngIf="scheduledExport">
      <div class="scheduled-exports-main-container scheduled-exports-content">
        <form [formGroup]="form" *ngIf="form" class="no-margin-bottom">
          <div class="export-form-grp">

            <div class="owner-name" *ngIf="!isNew">
              <wm-common-text
                [data]="{
                  text: 'Created by ' + scheduledExport.owner.name + ' (' + scheduledExport.owner.userName + ')',
                }"
              ></wm-common-text>
            </div>

            <div class="export-name">
              <!-- Added by Amisha on 2026-07-07.
                   Reason: pass the corrected required helper text through the shared text field
                   so the scheduled export validation copy reads clearly. -->
              <wm-common-textfield
                formControlName="name"
                [data]="{
                  label: 'Export Name',
                  id: 'export-name',
                  type: 'text',
                  required: true
                }"
              ></wm-common-textfield>
              <wm-control-message
                [control]="form.controls['name']"
              ></wm-control-message>
            </div>

            <div class="common-btn" *ngIf="scheduledExport.isEnabled">
              <wm-common-button
                [data]="{ text: 'DISABLE' }"
                (click)="disable()"
              ></wm-common-button>
            </div>
            <div class="export-status" *ngIf="scheduledExport.isEnabled">
              <wm-common-text
                [data]="{
                  text: 'This export is active.It will send exports based on the configured schedule.'
                }"
              ></wm-common-text>
            </div>

            <div class="common-btn" *ngIf="!scheduledExport.isEnabled">
              <wm-common-button
                [data]="{ text: 'ENABLE' }"
                (click)="enable()"
              ></wm-common-button>
            </div>
            <div class="export-status" *ngIf="!scheduledExport.isEnabled">
              <wm-common-text
                [data]="{
                  text: 'This export is disabled. It will not send any exports until it is enabled.'
                }"
              ></wm-common-text>
            </div>

            <div *ngIf="defaultFilters" class="filter-row">
              <!-- Added by Amisha on 2026-06-15. Reason: opt this Janus scheduled export editor
                   into the compact column-settings modal without affecting other filter-builder uses. -->
              <wm-filter-builder
                parentId="scheduled-export-editor"
                [id]="scheduledExportId"
                [staffFilterBuilder]="true"
                [janusScheduledExport]="true"
                [showSimpleSearch]="false"
                [filterTypes]="filterTypes"
                [savedFilters]="false"
                [params]="params"
                [columnOptions]="columnOptions"
                [onlyExportOptions]="true"
                (filtersChange)="handleFiltersChanged($event)"
                (exportColumnsChange)="handleColumnsChanged($event)"
                [shapefileValidationCriteria]="shapefileValidationCriteria"
              ></wm-filter-builder>
            </div>

            <form
              [formGroup]="roleRecipientForm"
              *ngIf="roleRecipientForm"
            >
              <div class="recipient-form-grp">

                <div class="common-text-bold">
                  <wm-common-text
                    [data]="{
                      text: 'Email Recipients',
                      variant: 'h3'
                    }"
                  ></wm-common-text>
                </div>

                <div class="role-dropdown">
                  <wm-common-dropdown
                    formControlName="role"
                    [data]="{
                      label: 'Role',
                      placeholder: 'Select Role',
                      options: roleOptions,
                      value: selectedRole
                    }"
                    (valueChange)="selectedRole = $event"
                  ></wm-common-dropdown>
                </div>

                <form [formGroup]="toEmailForm" class="no-margin-bottom">
                  <div class="form-grp-row">

                    <div class="email-field">
                      <wm-common-textfield
                        formControlName="newEmailAddress"
                        [data]="{
                          label: 'Recipient Email Address',
                          id: 'recipient-email-address',
                          type: 'text',
                          variant: 'outline',
                          placeholder: '',
                          helperText:
                            toEmailForm.get('newEmailAddress')?.touched &&
                            toEmailForm.get('newEmailAddress')?.invalid
                              ? 'Recipient Email Address is required'
                              : ''
                        }"
                      ></wm-common-textfield>
                    </div>

                    <div class="email-type">
                      <wm-common-dropdown
                        formControlName="newEmailType"
                        [data]="{
                          label: 'Type',
                          options: emailTypeOptions
                        }"
                        [formGroup]="toEmailForm"
                        (valueChange)="selectedEmailType = $event"
                      ></wm-common-dropdown>
                    </div>

                  </div>
                </form>

                <div class="common-btn add-btn">
                  <wm-common-button
                    [data]="{
                      text: 'ADD',
                      disabled: !canAddRecipient()
                    }"
                    (click)="addEmail()"
                  ></wm-common-button>
                </div>
              </div>
            </form>

            <div class="common-text-bold">
              <wm-common-text
                [data]="{
                  text: 'Recipients'
                }"
              ></wm-common-text>
              <mat-list>
                <mat-list-item
                  *ngFor="let toAddress of scheduledExport.scheduledExportEmailOptions.toRecipients"
                  class="recipient-item"
                >
                  <div matListItemTitle class="recipient-title">
                    <wm-common-text
                      [data]="{ text: 'Email: ' + toAddress }"
                    ></wm-common-text>
                  </div>
                  <div matListItemMeta class="recipient-actions">
                    <wm-common-text
                      [data]="{ text: 'To' }"
                    ></wm-common-text>
                    <wm-common-button
                      [data]="{
                        text: 'delete',
                        variant: 'icon',
                        className: 'delete-icon-btn'
                      }"
                      (click)="removeToAddress(toAddress)"
                    ></wm-common-button>
                  </div>
                </mat-list-item>
                <mat-list-item
                  *ngFor="let bccAddress of scheduledExport.scheduledExportEmailOptions.bccRecipients"
                  class="recipient-item"
                >
                  <div matListItemTitle class="recipient-title">
                    <wm-common-text
                      [data]="{ text: bccAddress }"
                    ></wm-common-text>
                  </div>
                  <div matListItemMeta class="recipient-actions">
                    <wm-common-text
                      [data]="{ text: 'BCC' }"
                    ></wm-common-text>
                    <wm-common-button
                      [data]="{
                        text: 'delete',
                        variant: 'icon',
                        className: 'delete-icon-btn'
                      }"
                      (click)="removeBCCAddress(bccAddress)"
                    ></wm-common-button>
                  </div>
                </mat-list-item>
                <mat-list-item
                  *ngFor="let ccAddress of scheduledExport.scheduledExportEmailOptions.ccRecipients"
                  class="recipient-item"
                >
                  <div matListItemTitle class="recipient-title">
                    <wm-common-text
                      [data]="{ text: ccAddress }"
                    ></wm-common-text>
                  </div>
                  <div matListItemMeta class="recipient-actions">
                    <wm-common-text
                      [data]="{ text: 'CC' }"
                    ></wm-common-text>
                    <wm-common-button
                      [data]="{
                        text: 'delete',
                        variant: 'icon',
                        className: 'delete-icon-btn'
                      }"
                      (click)="removeCCAddress(ccAddress)"
                    ></wm-common-button>
                  </div>
                </mat-list-item>
                <mat-list-item
                  *ngFor="let role of scheduledExport.scheduledExportEmailOptions.roleRecipients"
                  class="recipient-item"
                >
                  <div matListItemTitle class="recipient-title">
                    <wm-common-text
                      [data]="{ text: 'Role: ' + role.name }"
                    ></wm-common-text>
                  </div>
                  <div matListItemMeta class="recipient-actions">
                    <wm-common-text
                      [data]="{ text: 'To' }"
                    ></wm-common-text>
                    <wm-common-button
                      [data]="{
                        text: 'delete',
                        variant: 'icon',
                        className: 'delete-icon-btn'
                      }"
                      (click)="removeRole(role)"
                    ></wm-common-button>
                  </div>
                </mat-list-item>
              </mat-list>

              <wm-control-message
                [control]="form.controls['recipientSpecified']"
              ></wm-control-message>
            </div>

            <div class="export-name">
              <wm-common-textfield
                formControlName="subject"
                [data]="{
                  label: 'Subject',
                  id: 'subject',
                  required: true
                }"
              ></wm-common-textfield>
              <wm-control-message
                [control]="form.controls['subject']"
              ></wm-control-message>
            </div>

            <div class="common-text-bold">
              <!-- Added by Amisha on 2026-07-07.
                   Reason: the email body editor is validated as required but had no visible label marker,
                   so expose the requirement directly in the Janus editor UI. -->
              <wm-common-text
                [data]="{
                  text: 'Email Body',
                  required: true
                }"
              ></wm-common-text>
            </div>

            <div class="editor-wrapper">
              <ckeditor
                #emailBody
                [editor]="Editor"
                [config]="editorConfig"
                (change)="onChange($event)"
                formControlName="body"
              ></ckeditor>
              <wm-control-message
                [control]="form.controls['body']"
              ></wm-control-message>
            </div>

            <div class="common-text-bold">
              <!-- Added by Amisha on 2026-07-07.
                   Reason: match the visible required marker on export format with the actual form validation
                   applied in the scheduled export editor component. -->
              <wm-common-text
                [data]="{
                  text: 'Export Format',
                  required: true
                }"
              ></wm-common-text>
            </div>

            <div class="export-format-field">
              <wm-common-dropdown
                formControlName="exportFormat"
                [formGroup]="form"
                [data]="{
                  label: 'Export Format',
                  options: exportFormatOptions
                }"
              ></wm-common-dropdown>
            </div>

            <div class="schedule-section">
              <wm-schedule-editor
                #scheduleEditor
                [useMuiLayout]="true"
                [type]="scheduledExport.frequencyType"
                [options]="scheduledExport.scheduleFrequencyOptions"
                [existingNextExportOn]="scheduledExport.nextExportOnString"
                [form]="form"
              ></wm-schedule-editor>
            </div>

          </div>
        </form>
      </div>

      <!-- Action bar sits naturally inside the scrollable container below the form content -->
      <div class="action-bar" *ngIf="scheduledExport">
        <div class="delete-btn" *ngIf="!isNew">
          <wm-common-button
            [data]="{
              text: 'DELETE',
            }"
            (click)="delete()"
          ></wm-common-button>
        </div>

        <div class="cancel-btn">
          <wm-common-button
            [data]="{
              text: 'CANCEL',
            }"
            (click)="closeOverlay()"
          ></wm-common-button>
        </div>

        <div class="save-btn">
          <wm-common-button
            [data]="{
              text: 'SAVE',
            }"
            (click)="saveScheduledExport()"
          ></wm-common-button>
        </div>
      </div>
    </div>

    <div class="delete-modal" *ngIf="scheduledExport">
      <wm-common-confirmation-modal
        [data]="deleteModalData"
        (onYesClick)="confirmDelete()"
        (onNoClick)="closeDeleteModal()"
      >
      This export will no longer be sent. Are you sure you want to delete the scheduled export {{this.scheduledExport.name}}?
      </wm-common-confirmation-modal>
    </div>
  </div>
</div>
